import { createContext } from 'react';

export const FormErrorContext = createContext();
